import { createTheme } from '@mui/material'

const theme = createTheme({
  palette: {
    background: { paper: '#fff', default: '#fff' },
    primary: {
      light: '#2FC6BE',
      main: '#2BB5AE',
      dark: '#27A59E',
      contrastText: '#fff',
    },
    secondary: {
      light: '#fff',
      main: '#fff',
      dark: '#FBFDFD',
      contrastText: '#000',
    },
    warning: {
      light: '#FFAC30',
      main: '#FFAC30',
      dark: '#FFAC30',
      contrastText: '#fff',
    },
    error: {
      light: '#FB7670',
      main: '#FB7670',
      dark: '#FB7670',
      contrastText: '#fff',
    },
    text: {
      primary: '#000',
      secondary: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: 'rgba(0, 0, 0, 0.38)',
    },
  },
  typography: {
    fontFamily: '"Poppins","Roboto","Helvetica","Arial",sans-serif',
  },
  custom: {
    inputBorder: 'rgba(0,0,0,0.23)',
    bodyColor: '#f9fafb',
    stepHover: '#f3f7f7',
    hover: '#f5f5f5',
    boxShadowRight: '2px 0 2px -2px rgb(0 0 0 / 12%)',
    boxShadowColor: 'rgb(0 0 0 / 12%)',
    carCardMaxHeight: 153,
    carCardAdditionalMaxHeight: 221,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
        },
      },
    },
  },
})

export default theme
